export const BASE = "/";

export const ADMIN = "/admin";
export const ADMIN_HOME = "/admin/*";
export const ADMIN_USERS = "users";
export const ADMIN_LICENSE = "license";
export const ADMIN_GENERATIVE_AI = "generative-ai";
export const ADMIN_SHAREPOINT = "sharepoint";
export const ADMIN_INTEGRATIONS = "integrations";

export const SYSTEM_ADMIN = "/system-admin";
export const SYSTEM_ADMIN_HOME = "/system-admin/*";
export const SYSTEM_ADMIN_WORKSPACES = "workspaces";
export const SYSTEM_ADMIN_USERS = "users";
export const SYSTEM_ADMIN_LICENSE = "license";
export const SYSTEM_ADMIN_SECURITY = "security";
export const SYSTEM_ADMIN_GENERATIVE_AI = "generative-ai";
export const SYSTEM_ADMIN_SHAREPOINT = "sharepoint";
export const FEATURE_FLAGS = "/feature-flags";
export const FEATURE_FLAGS_HOME = "/feature-flags/*";
export const SYSTEM_ADMIN_INTEGRATIONS = "integrations";

export const CLOUD_ADMIN_EMAIL_SERVER = "email-server";

export const CLOUD_ADMIN = "/cloud-admin";
export const CLOUD_ADMIN_HOME = "/cloud-admin/*";
export const CLOUD_ADMIN_WORKSPACES = "workspaces";

export const SETUP = "/setup/*";
export const HELP = "/help";
export const STATUS = "/working";
export const SETTINGS_HOME = "/settings/*";
export const PROMPT_LIBRARY = "/prompt-library";
export const WATCHWORDS = "/watchwords/*";

export const USAGE_STATS = "/usage-stats";
export const USAGE_STATS_HOME = "/usage-stats/*";
export const USAGE_STATS_ACTIVITY = "/usage-stats/activity";
export const USAGE_STATS_VISI = "/usage-stats/visi";
export const USAGE_STATS_AI = "/usage-stats/ai";

export const USER_ADMIN = "/user-admin";
export const USER_ADMIN_HOME = "/user-admin/*";
export const USER_ADMIN_USERS = "";
export const USER_ADMIN_LICENSE = "license";
export const USER_ADMIN_INTEGRATIONS = "integrations";

export const CAPTURE_ROOT = "/capture";
export const CAPTURE_HOME = `${CAPTURE_ROOT}/*`;
export const CAPTURE_TRACKED_OPPS_ROOT = `${CAPTURE_ROOT}/tracked-opportunities`;
export const CAPTURE_ARCHIVED_OPPS_ROOT = `${CAPTURE_ROOT}/archived-opportunities`;
export const CAPTURE_OPPORTUNITIES_ROOT = `${CAPTURE_ROOT}/opportunities`;
export const CAPTURE_DASHBOARD = `${CAPTURE_ROOT}/dashboard`;
export const CAPTURE_DASHBOARD_ACTIVITY = `${CAPTURE_ROOT}/dashboard/activity`;

export const COLLECTIONS_HOME = "/collections/*";
export const PROPOSALS_ROOT = "/proposals";
export const PROPOSALS_HOME = `${PROPOSALS_ROOT}/*`;
export const PROPOSALS_KANBAN = `${PROPOSALS_ROOT}/kanban`;
export const PROPOSALS_ARCHIVED = `${PROPOSALS_ROOT}/archived`;
export const PROPOSALS_TIMELINE = `${PROPOSALS_ROOT}/kanban/timeline`;
export const PROPOSAL_DASHBOARD = `${PROPOSALS_ROOT}/dashboard`;
export const PROPOSAL_DASHBOARD_ACTIVITY = `${PROPOSALS_ROOT}/dashboard/activity`;
export const PROPOSAL_VIEW_ROOT = `${PROPOSALS_ROOT}/view`;
export const CONTRACTS_HOME = "/contracts/*";
export const POST_SUBMISSION_HOME = "/post-submission/*";
export const MISC_ANALYSIS_ROOT = "/misc-analysis";
export const MISC_ANALYSIS_HOME = `${MISC_ANALYSIS_ROOT}/*`;
export const MISC_ANALYSIS_VIEW_ROOT = `${MISC_ANALYSIS_ROOT}/view`;

export const NOTIFICATIONS_HOME = "/notifications";

export const DICTIONARIES_HOME = "/dictionaries";
export const getDictionaryPath = (id) => `/dictionaries/${id}`;
export const NEW_DICTIONARY = `${DICTIONARIES_HOME}/new_dictionary`;

export const EXCEPTION_ROOT = "/exception";
export const EXCEPTION_HOME = `${EXCEPTION_ROOT}/*`;
export const EXCEPTION_NOT_FOUND = "not-found";
export const EXCEPTION_ACCESS_DENIED = "access-denied/*";
export const EXCEPTION_PASSWORD = "password"; // NOSONAR javascript:S2068 - route path string, not a credential
export const EXCEPTION_SAML = "saml-error/*";
export const EXCEPTION_SESSION_EXPIRED = "session-expired";

export const PASSWORD_HOME = "/user/password/*"; // NOSONAR javascript:S2068 - route path string, not a credential
export const PASSWORD_RESET = "reset/:token"; // NOSONAR javascript:S2068 - route path string, not a credential
export const PASSWORD_RESET_EMAIL_SENT = "email-sent"; // NOSONAR javascript:S2068 - route path string, not a credential
export const PASSWORD_RESET_FORGOT = "recovery"; // NOSONAR javascript:S2068 - route path string, not a credential
export const PASSWORD_RESET_TEMPORARY = "expired"; // NOSONAR javascript:S2068 - route path string, not a credential
export const PASSWORD_CHANGED = "changed"; // NOSONAR javascript:S2068 - route path string, not a credential

export const DASHBOARD_HOME = "/user/dashboard/*";
export const WORKSPACE_HOME = "/workspace/*";
export const WORKSPACE = "/workspace";

export const REPORTS_HOME = "/reports/*";

export const CLOUD_USAGE = "/cloud-usage";
export const CLOUD_USAGE_HOME = "/cloud-usage/*";
export const CLOUD_USAGE_WORKSPACE_DETAIL_RELATIVE = "workspaces/:workspaceId";
export const buildCloudUsageWorkspaceDetailPath = (workspaceId) =>
  `${CLOUD_USAGE}/workspaces/${workspaceId}`;

export const LOGIN_HOME = "/login/*";
export const LOGIN = "/login";
export const ADD_IN_ABOUT = "/about";
export const LOGOUT = "/logged-out";
export const SAML_SUCCESS = "/saml-success";
export const MCP_OAUTH_CONSENT = "/mcp-oauth-consent";

export const SYSTEM_ADMIN_LOGIN = "/systemAdminLogin";
export const SYSTEM_ADMIN_LOGIN_HOME = "/systemAdminLogin/*";

// Routes reachable without a session. Anything else is only rendered once the session
// resolves as logged in — see SessionResolver.
export const SESSION_FREE_ROUTES = [
  LOGIN,
  SYSTEM_ADMIN_LOGIN,
  LOGOUT,
  SAML_SUCCESS,
  EXCEPTION_ROOT,
  "/user/password",
  "/setup",
];
